import React, { useState, useCallback, useEffect } from "react";
import { ClayToggle } from "@clayui/form";
import { ClaySelect, ClayInput } from "@clayui/form";
import ClayButton from "@clayui/button";
import C1TableCheckingDP from "./C1TableCheckingDP";
import C1TableCheckingKtoeDP from "./C1TableCheckingKtoeDP";
import { getProductAndForms } from "../../../../api/nebProductService";
import { NumericFormat } from "react-number-format";
import FuelBalanceChartTabsDP from "../FuelBalanceChartTabsDP";
import "../../../../App.css";
import {
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Modal,
  Button,
  Table,
  Badge,
  Accordion,
} from "react-bootstrap";

const C1TableDP = ({
  tabCode,
  tabTitle,
  energySector,
  viewMode,
  fetchedReport,
  updateCheckedFormsCount,
  agencyId,
  setFuelValuesC1Checking,
  setProductAndUnitC1Checking,
  selectedQuarter,
  selectedYear,
  reportStatus,
  combinedStructure,
  setCombinedStructure,
  reportMap,
  setReportMap,
  totalSellouts,
  isDisabled,
  onValidationChange
}) => {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [productAndFormsList, setProductAndFormsList] = useState([]);
  const [checkingReport, setCheckingReport] = useState();
  const [checkingReportKtoe, setCheckingReportKtoe] = useState();

  const [showKtoe, setShowKtoe] = useState(false);
  const handleKtoeToggle = (newVal) => {
    //(newVal) => setShowKtoe(newVal);
    setShowKtoe(newVal);

    document.getElementById('C1_unitoriginal').style.fontWeight = (newVal ? 'normal' : 'bold');
    document.getElementById('C1_unitktoe').style.fontWeight = (newVal ? 'bold' : 'normal');
  };

  const [showModal, setShowModal] = useState(false);
  const handleShowCheckingModal = () => setShowModal(true);
  const handleCloseCheckingModal = () => setShowModal(false);
  const [checked, setChecked] = useState(false);
  const [inputsPopulated, setInputsPopulated] = useState(false);
  const [c1Loading, setC1Loading] = useState(false);
  const [productAndUnit, setProductAndUnit] = useState([]);
  const [fuelValues, setFuelValues] = useState([]);
  const [plantRatio, setPlantRatio] = useState(0);
  const [productList, setProductList] = useState([]);
  const [formList, setFormList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getProductAndForms(agencyId, "C1-FECS");
        console.log("productAndFormsList is is:", result);
        setProductAndFormsList(result);
        console.log("debug c1: FETCHING P&F" + JSON.stringify(result, null, 2));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const inputStyle = {
    textAlign: "right",
    width: "100%",
    height: "30px",
    marginRight: "5px",
    borderRadius: "5px",
  };

  const handleFuelValueChange = (
    e,
    index,
    productName,
    parentFormFieldCode,
    formFieldName,
    formCode,
    subtractive
  ) => {
    const { floatValue = 0 } = e || {};
    let value = isNaN(Number(floatValue)) ? 0 : Number(floatValue);

    if (subtractive) {
      value = Math.abs(value);
    }

    setFuelValues((prevFuelValues) => {
      const exists = prevFuelValues.some((item) => item.index === index);
      const totalSellout = totalSellouts.find((s) => s[productName] !== undefined);
      const totalSelloutBalance = totalSellout ? totalSellout[productName] : 0;

      if (exists) {
        return prevFuelValues.map((item) => {
          if (item.index !== index) return item;

          // Get a deep copy of forms
          let updatedForms = [...item.forms];

          // Find the existing form
          const formIdx = updatedForms.findIndex(f => f.formCode === parentFormFieldCode);

          if (formIdx !== -1) {
            const existingForm = updatedForms[formIdx];
            const updatedCategories = [
              ...existingForm.categories.filter(c => c.formCode !== formCode),
              {
                formCode,
                value,
                description: formFieldName,
              }
            ];

            // Replace the existing form
            updatedForms[formIdx] = {
              ...existingForm,
              categories: updatedCategories,
            };
          } else {
            // Add new form
            updatedForms.push({
              formCode: parentFormFieldCode,
              categories: [
                {
                  formCode,
                  value,
                  description: formFieldName,
                },
              ],
            });
          }

          // ✅ Deduplicate forms by formCode (safety net)
          const seen = new Set();
          updatedForms = updatedForms.filter(f => {
            if (seen.has(f.formCode)) return false;
            seen.add(f.formCode);
            return true;
          });

          const newBalance = updatedForms.reduce((sum, form) => {
            return sum + form.categories.reduce((catSum, cat) => {
              return catSum + parseFloat(Number(cat.value || 0).toFixed(4));
            }, 0);
          }, 0);

          const finalBalance = parseFloat(totalSelloutBalance - newBalance).toFixed(4);
          return {
            ...item,
            forms: updatedForms,
            balance: parseFloat(finalBalance),
          };
        });
      } else {
        // New row
        const newForms = [
          {
            formCode: parentFormFieldCode,
            categories: [
              {
                formCode,
                value,
                description: formFieldName,
              },
            ],
          },
        ];

        const newBalance = newForms.reduce((sum, form) => {
          return sum + form.categories.reduce((catSum, cat) => {
            return catSum + parseFloat(Number(cat.value || 0).toFixed(4));
          }, 0);
        }, 0);

        const finalBalance = parseFloat(totalSelloutBalance - newBalance).toFixed(4);

        return [
          ...prevFuelValues,
          {
            index,
            productName,
            balance: parseFloat(finalBalance),
            forms: newForms,
          },
        ];
      }
    });
  };


  const handleUnitChange = (event, rowIndex, productName) => {
    const selectedUnit = event.target.value;
    console.log(
      `handleUnitChange triggered for productName: ${productName}, rowIndex: ${rowIndex}, selectedUnit: ${selectedUnit}`
    );

    // Directly set or update the unit for the product
    setProductAndUnit((prevUnits) => {
      // Create a copy of the current state
      const updatedUnits = [...prevUnits];

      // Find the index of the product in the array
      const unitIndex = updatedUnits.findIndex((unit) => unit.fieldName === productName);

      if (unitIndex > -1) {
        // Update existing entry
        updatedUnits[unitIndex] = { ...updatedUnits[unitIndex], unit: selectedUnit };
        console.log(`Updated unit for productName: ${productName}`);
      } else {
        // Add new entry if it doesn't exist
        updatedUnits.push({ fieldName: productName, unit: selectedUnit });
        console.log(`Added new unit for productName: ${productName}`);
      }

      console.log("Updated productAndUnit state:", updatedUnits);
      return updatedUnits; // Return the updated array
    });
  };


  /**
   * useEffect, rendering with dependencies
   */


  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getProductAndForms(agencyId, "C1-FECS");
        setProductAndFormsList(result);
        console.log("debug c1: FETCHING P&F" + JSON.stringify(result, null, 2));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  //After rows changes, headers is formed
  useEffect(() => {
    if (productAndFormsList.length === 0) return;
    const dynamicHeaders = [
      { id: "no", name: "No." },
      { id: "product", name: "Product" },
      { id: "unit", name: "Unit" },
      { id: "balance", name: "Balance" },
      ...productAndFormsList[0].forms.map((form) => ({
        id: form.formFieldCode,
        name: `${form.formFieldName}`,
      })),
    ];
    console.log("headers -->", dynamicHeaders);
    setHeaders(dynamicHeaders);
  }, [rows]);


  // const [combinedStructure, setCombinedStructure] = useState(null);

  useEffect(() => {
    const formsMap = {};

    fuelValues.forEach((fuelItem) => {
      fuelItem.forms.forEach((form) => {
        if (!formsMap[form.formCode]) {
          formsMap[form.formCode] = {
            formCode: form.formCode,
            categories: [],
          };
        }

        form.categories.forEach((category) => {
          const product = {
            fieldName: fuelItem.productName,
            value: Math.abs(category.value), // ensure always positive
            unit:
              productAndUnit.find(
                (item) => item.fieldName === fuelItem.productName
              )?.unit || "",
          };

          const categoryIndex = formsMap[form.formCode].categories.findIndex(
            (cat) => cat.formCode === category.formCode
          );

          if (categoryIndex !== -1) {
            formsMap[form.formCode].categories[categoryIndex].products.push(
              product
            );
          } else {
            formsMap[form.formCode].categories.push({
              formCode: category.formCode,
              description: category.description,
              products: [product],
            });
          }
        });
      });
    });

    const formsArray = Object.values(formsMap);
    console.log("formsArray >>> ", formsArray);

    setReportMap((prevState) => ({
      ...prevState,
      reportPeriodYear: selectedYear,
      reportQuarter: selectedQuarter,
      forms: [
        // Remove existing forms with the same formCode
        ...prevState.forms.filter(
          (form) =>
            !formsArray.some((newForm) => newForm.formCode === form.formCode)
        ),
        // Add the updated forms
        ...formsArray,
      ],
    }));
  }, [fuelValues, productAndUnit, selectedQuarter, selectedYear]);

  useEffect(() => {
    setCombinedStructure(reportMap);
  }, []);


  useEffect(() => {
    if (productAndFormsList.length === 0) return;

    const updatedFuelValues = productAndFormsList.map((product, rowIndex) => {
      const fuelObject = {
        index: rowIndex + 1,
        productName: product.productName,
        balance: 0,
        forms: [],
      };

      if (fetchedReport?.forms?.length) {
        fetchedReport.forms.forEach((formCategory) => {
          formCategory.categories.forEach((category) => {
            category.products.forEach((fetchedProduct) => {
              if (fetchedProduct.fieldName === product.productName) {
                product.forms.forEach((form) => {
                  if (category.formCode === form.formFieldCode) {
                    const formValue = fetchedProduct.value || 0;
                    const selectedUnit = fetchedProduct.unit || "";

                    setProductAndUnit((prevUnits) => {
                      const updatedUnits = [...prevUnits];
                      const unitIndex = updatedUnits.findIndex((u) => u.fieldName === product.productName);

                      if (unitIndex > -1) {
                        updatedUnits[unitIndex] = { ...updatedUnits[unitIndex], unit: selectedUnit };
                      } else {
                        updatedUnits.push({ fieldName: product.productName, unit: selectedUnit });
                      }
                      return updatedUnits;
                    });

                    // Check if form already exists, and merge if needed
                    let existingForm = fuelObject.forms.find(f => f.formCode === form.parentFormFieldCode);
                    if (!existingForm) {
                      existingForm = { formCode: form.parentFormFieldCode, categories: [] };
                      fuelObject.forms.push(existingForm);
                    }

                    // Deduplicate category
                    const catIndex = existingForm.categories.findIndex(c => c.formCode === form.formFieldCode);
                    if (catIndex !== -1) {
                      existingForm.categories[catIndex] = {
                        formCode: form.formFieldCode,
                        value: formValue,
                        description: form.formFieldName,
                      };
                    } else {
                      existingForm.categories.push({
                        formCode: form.formFieldCode,
                        value: formValue,
                        description: form.formFieldName,
                      });
                    }
                  }
                });
              }
            });
          });
        });
      }

      // Compute initial balance
      const totalSellout = totalSellouts.find(s => s[product.productName] !== undefined);
      const totalSelloutBalance = totalSellout ? totalSellout[product.productName] : 0;

      const formBalance = fuelObject.forms.reduce((sum, form) => {
        return sum + form.categories.reduce((catSum, cat) => {
          return catSum + parseFloat(Number(cat.value || 0).toFixed(4));
        }, 0);
      }, 0);

      fuelObject.balance = parseFloat((totalSelloutBalance - formBalance).toFixed(4));
      return fuelObject;
    });

    console.log("fuel values lalalala >>>", updatedFuelValues);
    // Only update state if values have changed
    setFuelValues((prev) => {
      const isEqual = JSON.stringify(prev) === JSON.stringify(updatedFuelValues);
      return isEqual ? prev : updatedFuelValues;
    });
  }, [productAndFormsList, fetchedReport]);


  // ✅ Second useEffect: Render form inputs and handle balance 
  useEffect(() => {
    if (productAndFormsList.length === 0 || fuelValues.length === 0) return;

    const updatedRows = productAndFormsList.map((product, index) => {
      const row = {
        no: index + 1,
        product: product.productName,
      };

      const fuelObject = fuelValues.find((fuel) => fuel.index === index + 1);
      console.log("fuelObject are you there >>>", fuelObject);

      // Render numeric inputs for each form field
      product.forms.forEach((form) => {
        const fieldValue =
          fuelObject?.forms
            ?.flatMap((f) => f.categories)
            ?.find((cat) => cat.formCode === form.formFieldCode)?.value ?? "";

        row[form.formFieldCode] = (
          <NumericFormat
            className="no-spinner"
            key={`${index + 1}_${form.formFieldCode}`}
            disabled={isDisabled}
            style={inputStyle}
            id={`draft_fb_num_${product.productName}_${form.formFieldCode}`}
            onValueChange={(values) => {
              handleFuelValueChange(
                values,
                index + 1,
                product.productName,
                form.parentFormFieldCode,
                form.formFieldName,
                form.formFieldCode,
                form.subtractive
              );
            }}
            value={fieldValue}
            valueIsNumericString
            customInput={ClayInput}
            thousandSeparator
            decimalScale={4}
            fixedDecimalScale
            allowNegative={false}
          />
        );
      });

      // Render unit select
      row.unit = (
        <ClaySelect
          id={`draft_fb_selectUnit_${product.productName}`}
          key={`selectUnit_${product.productName}`}
          disabled={isDisabled}
          onChange={(e) => handleUnitChange(e, index, product.productName)}
          value={
            productAndUnit.find((unit) => unit.fieldName === product.productName)?.unit || ""
          }
        >
          <option value="">Select...</option>
          {product.units.map((unit, unitIndex) => (
            <option key={unitIndex} value={unit.productUnitName}>
              {unit.productUnitName}
            </option>
          ))}
        </ClaySelect>
      );

      // Use balance from fuelObject if available
      const isStandalone = product.standalone;
      const totalSellout = totalSellouts.find((s) => s[product.productName] !== undefined);
      const totalSelloutBalance = isStandalone ? totalSellout?.[product.productName] ?? 0 : 0;

      let balance = 0;
      if (fuelObject && typeof fuelObject.balance === "number") {
        balance = fuelObject.balance;
      } else {
        balance = totalSelloutBalance;
      }

      console.log("balance should be >>>", totalSelloutBalance, balance);

      row.balance = (
        <span
          style={{
            paddingRight: "10px",
            display: "block",
            textAlign: "right",
          }}
        >
          <NumericFormat
            displayType="text"
            value={balance.toFixed(4)}
            thousandSeparator
            decimalScale={4}
            fixedDecimalScale
          />
        </span>
      );

      return row;
    });

    setRows(updatedRows);
  }, [fuelValues, productAndFormsList, totalSellouts, isDisabled, productAndUnit]);

  //third useeffect to calculate TotalSellOuts
  useEffect(() => {
    console.log("recalculating useEffect totalSellouts:-",totalSellouts);
    if (fuelValues.length === 0 || totalSellouts.length === 0) return;

    const updated = fuelValues.map((fuel) => {
      const totalSellout = totalSellouts.find((s) => s[fuel.productName] !== undefined);
      const totalSelloutBalance = totalSellout ? totalSellout[fuel.productName] : 0;

      const formBalance = fuel.forms.reduce((sum, form) => {
        return sum + form.categories.reduce((catSum, cat) => {
          return catSum + parseFloat(Number(cat.value || 0).toFixed(4));
        }, 0);
      }, 0);

      return {
        ...fuel,
        balance: parseFloat((totalSelloutBalance - formBalance).toFixed(4)),
      };
    });

    // Only update state if different
    const isEqual = JSON.stringify(updated) === JSON.stringify(fuelValues);
    if (!isEqual) {
      setFuelValues(updated);
    }
  }, [totalSellouts, fuelValues]);

  //Validation
  useEffect(() => {
    const listErrors = {};

    let atLeastOneUnitSelected = false;
    let atLeastOneProductFilled = false;

    fuelValues.forEach((fuelItem, index) => {
      console.log("fuelItem balance-->", fuelItem.productName, fuelItem.balance);
      const sanitizedProductName = fuelItem.productName.replace(/[^a-zA-Z0-9]/g, '');
      const productKey = `${index}_unit_${sanitizedProductName}`;

      const productUnit = productAndUnit.find((item) => item.fieldName === fuelItem.productName)?.unit;

      if (productUnit) {
        atLeastOneUnitSelected = true;

        const isAtLeastOneFieldFilled = fuelItem.forms.some((form) =>
          form.categories.some((category) => category.value !== 0)
        );

        if (isAtLeastOneFieldFilled) {
          atLeastOneProductFilled = true;

          if (Math.abs(fuelItem.balance) > 1e-6) {
            listErrors[`${index}_balance_${sanitizedProductName}`] =
              `Balance must be 0 for ${fuelItem.productName}`;
          }
        } else {
          listErrors[`${index}_fields_${sanitizedProductName}`] =
            `At least one field must be filled for ${fuelItem.productName}`;
        }
      }
    });

    if (!atLeastOneUnitSelected) {
      listErrors["unit_selection"] = `At least one product unit must be selected.`;
    }

    if (atLeastOneUnitSelected && !atLeastOneProductFilled) {
      listErrors["general"] = `At least one product must have a value.`;
    }

    console.log("Final Validation Errors:", listErrors);

    if (typeof onValidationChange === 'function') {
      onValidationChange({ [tabTitle]: listErrors });
    }
  }, [JSON.stringify(fuelValues), productAndUnit]);

  //changes in F4-SEU standalone product in FB will be detected here for balance calculation since cannot be detected in handleFuelValueChange
  // Update fuelValues when totalSellouts changes to reflect the changes in balance

  useEffect(() => {
    if (productAndFormsList.length !== 0) {
      // Ensure ktoe conversion runs only when `combinedStructure` changes
      const ktoeReport = convertToKtoe(combinedStructure);
      setCheckingReport(combinedStructure); // Original report
      setCheckingReportKtoe(ktoeReport); // ktoe-converted report
    }
  }, [combinedStructure]); // Updated dependency to fix potential rerender issues

  function convertToKtoe(report) {
    if (!report?.forms) return report; // Early return if forms don't exist

    // Deep clone the report to avoid mutating the original state
    const updatedReport = {
      ...report,
      forms: report.forms.map((form) => ({
        ...form,
        categories: form.categories.map((category) => ({
          ...category,
          products: category.products.map((product) => {
            const matchingProduct = productAndFormsList.find(
              (p) => p.productName === product.fieldName
            );

            if (matchingProduct) {
              const matchingUnit = matchingProduct.units.find(
                (unit) =>
                  unit.productUnitName === product.unit ||
                  unit.productUnitName === "ktoe"
              );

              if (matchingUnit?.inKtoe !== undefined) {
                return {
                  ...product,
                  value: product.value * matchingUnit.inKtoe,
                  unit: "ktoe",
                };
              } else {
                console.log("debugc1: matching unit not found");
                console.error(
                  `Matching unit or ktoe value not found for product: ${product.fieldName}`
                );
              }
            } else {
              console.log(
                "debugc1: matching product not found: " + product.fieldName
              );
              console.log(
                "debugc1: productAndFormsList: " +
                JSON.stringify(productAndFormsList, null, 2)
              );
            }
            return { ...product }; // Return the original product if no matching product is found
          }),
        })),
      })),
    };
    return updatedReport;
  }

  //check if form is balanced and have no missing unit
  useEffect(() => {
    setFuelValuesC1Checking(fuelValues);
  }, [fuelValues]);

  useEffect(() => {
    setProductAndUnitC1Checking(productAndUnit);
  }, [productAndUnit]);

  return (
    <div>
      {c1Loading ? <div style={{ textAlign: "center" }}>Loading...</div> : null}

      <Button
        variant="success"
        size="sm"
        style={{ minWidth: "7em" }}
        onClick={handleShowCheckingModal}
      >
        {reportStatus === "Approved" ? "View Report" : "Check"}
      </Button>
      <br /><br />

      <Accordion defaultActiveKey={["0"]} alwaysOpen>
        {rows.map((row) => (
          <div>
            <Accordion.Item eventKey={row.no} className="mb-1">
              <Accordion.Header className="accordion-bg-color1">
                {row.no}. {row.product}
              </Accordion.Header>
              <Accordion.Body>
                <Table
                  responsive
                  bordered
                  hover
                  size="sm"
                  className="mt-1"
                  style={{ width: "45em" }}
                >
                  <tbody>
                    {headers.map((column) =>
                      column.id === "no" ? (
                        ""
                      ) : (
                        <tr>
                          <td className="text-bold" style={{ width: "25em" }}>
                            {column.name}
                          </td>
                          <td
                            className={
                              column.id === "product"
                                ? "text-bold text-uppercase"
                                : ""
                            }
                          >
                            {row[column.id]}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </div>
        ))}
      </Accordion>
      <br />

      {/* <FuelBalanceChartTabsDP
        energySector={energySector}
        plantRatio={plantRatio}
        selectedYear={selectedYear}
        selectedQuarter={selectedQuarter}
        productList={productList}
        formList={formList}
        productAndFormsList={productAndFormsList}
        agencyId={agencyId}
      /> */}

      <Modal size="xl" show={showModal} onHide={handleCloseCheckingModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {reportStatus === "Approved" ? "View Report" : "Confirm Submission"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {reportStatus !== "Approved" && (
              <div className="mb-3">
                Check all numbers, balances or units in your Fuel Balance.{" "}
              </div>
            )}

            <Form.Group className="row form-group-sm mb-2">
              <div className="col-12">
                <span className="mr-2" id="C1_unitoriginal" style={{ fontWeight: showKtoe ? 'normal' : 'bold' }}>Original unit</span>
                <ClayToggle
                  onToggle={handleKtoeToggle}
                  toggled={showKtoe}
                />
                <span className="ml-1" id="C1_unitktoe" style={{ fontWeight: showKtoe ? 'bold' : 'normal' }}>In ktoe</span>
              </div>
            </Form.Group>

            {!showKtoe ? (
              <C1TableCheckingDP
                agencyId={agencyId}
                checkingReport={checkingReport}
                totalSellouts={totalSellouts}
                productAndFormsList={productAndFormsList}
              />
            ) : (
              <C1TableCheckingKtoeDP
                agencyId={agencyId}
                checkingReportOriginalUnit={checkingReport}
                checkingReportKtoe={checkingReportKtoe}
                totalSellouts={totalSellouts}
                productAndFormsList={productAndFormsList}
              />
            )}
          </div>
        </Modal.Body>
        {/*<Modal.Footer>
           <button className="btn btn-outline-secondary mr-1" onClick={handleCloseCheckingModal}>
              Close
            </button>
            <button
                  onClick={() => submitReport("Draft")}
                  className="btn btn-outline-primary mr-1"
                >
                  Save As Draft
                </button>
            <button className="btn btn-primary mr-1" onClick={handleShowConfirmationModal}>
              Submit
            </button> 
        </Modal.Footer>*/}
      </Modal>
    </div>
  );
};

export default C1TableDP;
